import { range } from 'lodash';
import React from 'react';

import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

// Includes a shimmer state for the working Summary Row
// as that data currently comes from the same request
// as the rest of the list. When we update the summary row metrics query
// and seperate the two fetches, we can remove the summary row shimmer
// here and consolidate our Placeholder components once again.
export const OperationsListItemPlaceholder = () => (
  <>
    <div>
      {range(0, 15).map((i) => (
        <div
          key={`placeholder-${i}`}
          className="-ml-6  mr-1.5 flex h-10 items-center justify-between pl-6 pt-2 transition-colors"
        >
          <div style={{ width: `${Math.abs(Math.sin(i)) * 25 + 40}%` }}>
            <ShimmerLoading className="h-6 w-full rounded " />
          </div>

          <ShimmerLoading className="h-6 w-[12%] rounded " />
        </div>
      ))}
    </div>
  </>
);
